/* eslint-disable global-require, no-use-before-define */

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { BrowserRouter } from 'react-router-dom';
import { AppContainer } from 'react-hot-loader';
import { I18nextProvider } from 'react-i18next';
import * as Sentry from '@sentry/browser';

import App from 'components/App';
import i18next from './i18next-config';
import configureStore from './configureStore';
import config from './config';

import 'styles/app.scss';
import './gtm';

const { basename, sentry } = config;
const store = configureStore();

if (sentry) {
  Sentry.init(sentry.config);
}

if (!window.Intl) {
  import('intl').then(_ => {
    render();
  });
} else {
  render();
}

function render() {
  ReactDOM.render(
    <Suspense fallback={<div />}>
      <I18nextProvider i18n={i18next}>
        <Provider store={store}>
          <BrowserRouter basename={basename}>
            <AppContainer>
              <App />
            </AppContainer>
          </BrowserRouter>
        </Provider>
      </I18nextProvider>
    </Suspense>,
    document.getElementById('root'),
  );
}
